module.exports = __webpack_public_path__ + "img/windows-server-2019-dev.3591ffde.jpg";